import React, { PureComponent } from 'react';
import TablaRow from './TablaRow'
import TablaRowEdicion from './TablaRowEdicion'

class TablaBody extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            estaDesplegado: false
        }

        this.setEstaDesplegado = this.setEstaDesplegado.bind(this);
    }

    setEstaDesplegado(estadoDesplegado) {
        this.setState({
            estaDesplegado: estadoDesplegado
        });
    }

    render() {
        const { state, setEstaDesplegado } = this;
        const { getCodigo, ingresoAjuste, ajustes, confirmarAjuste, denegarAjuste, editar, eliminarAjuste, expandirRow, rowSeleccionada, permisosUsuario, siNoConfirmacion, classScroll } = this.props;
        let ajusteMock = [{ Id: 1, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "Crédito Cash out CVU", DebitoCredito: 1, ImporteTotalPesos: 1231, Estado: "Pend. Confirmación" },
        { Id: 2, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "IVA RG 4240/20182", DebitoCredito: 0, ImporteTotalPesos: 3000, Estado: "Anulado" },
        { Id: 3, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "IVA RG 4240/2018e sí", DebitoCredito: 0, ImporteTotalPesos: 12, Estado: "Confirmado" },
        { Id: 4, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "GASTOS ACCIONES JUDICIALESe no", DebitoCredito: 0, ImporteTotalPesos: 19700, Estado: "Enviado" },
        { Id: 5, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "GASTOS ACCIONES JUDICIALESuan", DebitoCredito: 1, ImporteTotalPesos: 2345, Estado: "Denegado" },
        { Id: 6, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "IVA RG 4240/20182", DebitoCredito: 1, ImporteTotalPesos: 1, Estado: "Aceptado por la Administradora" },
        { Id: 7, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "IVA RG 4240/20182", DebitoCredito: 0, ImporteTotalPesos: 980, Estado: "Rechazado por la Administradora" },
        { Id: 8, FechaValor: "2020-05-28 00:00:00.000", FechaImputacion: "2020-05-28 00:00:00.000", Motivo: "IVA RG 4240/20182", DebitoCredito: 1, ImporteTotalPesos: 554, Estado: "Anulado" }]
        let ajustesRow = [];
        if (ajustes.length > 0) {
            ajustes.map((ajuste, index) => {

                let backColor = index % 2 != 0 ? ' backgroundTableLightBlue' : '';
                let claseFlecha = rowSeleccionada == ajuste.Id ? "clickable none-text-decoration seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "clickable none-text-decoration seccionRenglonesModelo__renglonModelo__trianguloDown"

                ajustesRow.push(
                    <TablaRow ingresoAjuste={ingresoAjuste}
                        ajuste={ajuste}
                        expandirRow={expandirRow}
                        claseFlecha={claseFlecha}
                        confirmarAjuste={confirmarAjuste}
                        getCodigo={getCodigo}
                        denegarAjuste={denegarAjuste}
                        editar={editar}
                        eliminarAjuste={eliminarAjuste}
                        permisosUsuario={permisosUsuario}
                        state={state}
                        setEstaDesplegado={setEstaDesplegado}
                        backColor={backColor}
                        siNoConfirmacion={siNoConfirmacion}
                    />
                );

                if (rowSeleccionada != undefined && rowSeleccionada == ajuste.Id) {
                    ajustesRow.push(
                        <TablaRowEdicion ajuste={ajuste} state={state} backColor={backColor} siNoConfirmacion={siNoConfirmacion} />
                    );
                }
            });
        }

        return (
            <tbody className={classScroll}>
                {ajustesRow}
            </tbody>);
    }
}

export default TablaBody;